import './styles.css';
import * as ko from 'knockout'; // Importing Knockout.js
import MainViewModel from './viewModels/MainViewModel';
import './components/ResidentMultiSelect'; // Import the component
import './components/ServiceProviderMultiSelect'; // Import the service provider component
import './bindings/germanDatepicker'; // German date picker for Schadentag fields
import { clearSession } from './utils';
// --- Version Info (visible in browser console) ---
const buildTimestamp = process.env.BUILD_TIMESTAMP;
const buildDate = new Date(buildTimestamp);
const formattedDate = buildDate.toLocaleDateString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
});
console.log('%c INCONconnect %c Build: ' + formattedDate + ' ', 'background: #1e40af; color: #fff; font-weight: bold; font-size: 14px; padding: 4px 8px; border-radius: 4px 0 0 4px;', 'background: #e0e7ff; color: #1e40af; font-weight: bold; font-size: 14px; padding: 4px 8px; border-radius: 0 4px 4px 0;');
function bootstrap() {
    ko.applyBindings(new MainViewModel());
}
// Ein defekter Sitzungsrest (z. B. ein Token einer älteren Version) darf das Formular nicht unbenutzbar machen:
// ohne angewendete Bindings blieben sonst alle Bereiche inklusive des Erfolgs-Overlays sichtbar.
try {
    bootstrap();
}
catch (error) {
    console.error('INCONconnect: Start fehlgeschlagen – Sitzung wird zurückgesetzt und neu gestartet', error);
    try {
        // im try: scheitert schon das Aufräumen, muss trotzdem die Fehlerseite erscheinen
        clearSession();
        ko.cleanNode(document.body);
        bootstrap();
    }
    catch (retryError) {
        console.error('INCONconnect: Start endgültig fehlgeschlagen', retryError);
        document.body.innerHTML = '<div style="font-family: sans-serif; padding: 2rem; max-width: 40rem; margin: auto">'
            + '<h1 style="font-size: 1.25rem">Das Formular konnte nicht geladen werden.</h1>'
            + '<p>Bitte laden Sie die Seite neu. Bleibt der Fehler bestehen, löschen Sie die Website-Daten dieser Seite oder wenden Sie sich an INCON.</p></div>';
    }
}
